import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import DailyOperationsContainer from './DailyOperations';

export const DailyOperationsModule = () => (
  <Route
    exact
    path={APP_ROUTES.OPERATION_MODULE.CHILDREN?.DAILY_OPERATIONS.PATH}
    component={DailyOperationsContainer}
  />
);
